import Student from '@/api/home/student'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  notificationTypes: [],
  not_type_id: [],
  date_from: moment()
    .add(-1, 'Month')
    .format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  },
  SET_NOTIFICATION_TYPES(state, data) {
    state.notificationTypes = data
  },
  SET_NOT_TYPE_ID(state, data) {
    state.not_type_id = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    let params = Object.assign({
      page: context.state.pagination.page,
      perPage: context.state.pagination.perPage,
      search: context.state.search,
      date_from: context.state.date_from,
      date_to: context.state.date_to,
      not_type_id: context.state.not_type_id,
      ...attributes
    })
    return Student.getNotificationHistory({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  async fetchResource(context) {
    if (!context.state.notificationTypes.length > 0) {
      let response = await Student.getNotificationTypes()
      context.commit('SET_NOTIFICATION_TYPES', response.data)
    }
  }
}
